import trim from 'lodash/trim'

// #EXT-X-IMAGE-STREAM-INF:BANDWIDTH=21755,CODECS="jpeg",RESOLUTION=312x176,URI="test-1080_Thumbnail_I-Frame.m3u8"

export const parseImageStreamUriFromManifest = (manifest, baseUrl) => {
  const match = manifest.match(/#EXT-X-IMAGE-STREAM-INF:(.*)\n/)
  if (!match) return null

  const uriPart = match?.[1].split(',').find((part) => part.startsWith('URI'))
  if (!uriPart) return null

  return `${baseUrl}/${trim(uriPart.substring(uriPart.indexOf('=') + 1), '"')}`
}
